/**
 * 500 — внутренняя ошибка сервера.
 * Используется как fallback от React ErrorBoundary и для роута /500.
 */
import { ErrorLayout, ErrorBlock } from '@/components/layout/ErrorLayout'
import { Button } from '@/components/ui/Button'

export function ServerError({ onReload }: { onReload?: () => void }) {
  return (
    <ErrorLayout>
      <ErrorBlock
        icon="server-crash"
        iconTone="danger"
        title="У нас проблема 🛠️"
        body={
          <p>
            Что-то сломалось на нашей стороне. Мы уже знаем — команда чинит. Попробуй обновить страницу через минуту.
          </p>
        }
        actions={
          <>
            <Button variant="primary" onClick={() => (onReload ? onReload() : window.location.reload())}>Обновить</Button>
            <Button asChild variant="secondary"><a href="/">На главную</a></Button>
            <Button asChild variant="ghost"><a href="mailto:support@agentceo.ru">support@agentceo.ru</a></Button>
          </>
        }
      />
    </ErrorLayout>
  )
}
